var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OareContentView',{attrs:{"title":"About"}},[_c('div',{staticClass:"title font-weight-regular"},[_c('page-content',{attrs:{"pageName":"about"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }